import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ReportConfiguration, ReportListElement} from '../models/reports.model';
import {SearchQueryParams} from '../models/search-query-params.model';

@Injectable()
export class ReportsService {
    baseUrl = '/api/secured/reports';

    constructor(private http: HttpClient) {
    }

    getReports() {
        return this.http.get<ReportListElement[]>(`${this.baseUrl}`);
    }

    getReportConfiguration(reportCode: string) {
        return this.http.get<ReportConfiguration>(`${this.baseUrl}/${reportCode}/configuration`);
    }

    generateReport(reportCode: string, props: SearchQueryParams) {
        return this.http.get(`${this.baseUrl}/${reportCode}/export`, {params: props.getHttpParams(), observe: 'response'});
    }
}
